import { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MSkeleton } from '@Components/Base';
import { RequestListSearchResponse } from '@Types/api/requestList';
import { PurchaseFormResponse } from '@Types/api/form';
import RequestType from '@Types/common/RequestTypes';
import { RequestListContext } from '@Components/types/RequestListContext';
import { NoData } from '@Features/MaterialRequest/requests/components/NoData';

import useSmartMapper from './hook/useSmartMapper';
import Card from './components/Card';
import styles from './request-list-mobile.module.css';

type ListRequests = RequestListSearchResponse<PurchaseFormResponse>;

type RequestsDataList = Array<PurchaseFormResponse>;

export interface RequestListMobileProps {
  listRequests?: ListRequests;
  requestsDataList?: RequestsDataList;
  requestType: RequestType;
  onImport?: (recordKey: string) => void;
  onExport?: (requestNo: string) => void;
  onView?: (recordKey: string) => void;
  onDelete?: (requestNo: string) => void;
  onLoadMore?: (nextPage?: number) => void;
  showAction?: boolean;
  context?: RequestListContext;
  isFiltersApplied?: boolean;
  isSearchApplied?: boolean;
}

const RequestListMobile = ({
  listRequests,
  requestsDataList,
  requestType,
  showAction = true,
  onLoadMore,
  onImport,
  onExport,
  onView,
  onDelete,
  context = 'my-requests',
  isFiltersApplied = false,
  isSearchApplied = false,
}: RequestListMobileProps): JSX.Element | null => {
  const { transformItem } = useSmartMapper(requestType);
  const [nextPage, setNextPage] = useState(1);

  if (
    !listRequests?.content ||
    !listRequests?.content?.length ||
    !requestsDataList?.length
  ) {
    return (
      <NoData
        context={context}
        isFiltersApplied={isFiltersApplied}
        isSearchApplied={isSearchApplied}
      />
    );
  }

  return (
    <div className={styles.requestListMobile}>
      <InfiniteScroll
        next={() => {
          setNextPage(nextPage + 1);
          onLoadMore?.(nextPage);
        }}
        hasMore={requestsDataList.length < listRequests?.totalElements}
        loader={<MSkeleton paragraph={{ rows: 1 }} active />}
        dataLength={requestsDataList.length}
        scrollableTarget="scrollableList"
        endMessage={
          <p style={{ textAlign: 'center', textTransform: 'uppercase' }}>
            No more data
          </p>
        }
      >
        {requestsDataList.map((item) => {
          const requestItemId = item.reqId;

          const {
            requestType: requestTypeValue,
            status,
            items,
          } = transformItem(item);

          return (
            <Card
              key={requestItemId}
              requestType={`PR no. ${requestTypeValue}`}
              status={status}
              requestNo={requestItemId}
              items={items}
              showAction={showAction}
              onImport={() => onImport?.(String(item.bsReqId))}
              onExport={() => onExport?.(String(requestItemId))}
              onView={() => onView?.(String(requestItemId))}
              onDelete={() => onDelete?.(String(requestItemId))}
            />
          );
        })}
      </InfiniteScroll>
    </div>
  );
};

export default RequestListMobile;
